
import { EventEmitter, Injectable, Output } from '@angular/core';
import { PortalService } from './portal.service';
import { BehaviorSubject, filter } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageService } from './page.service';


@Injectable({
  providedIn: 'root'
})
export class NavService {

  @Output()
  menuUpdate: EventEmitter<string> = new EventEmitter<string>();
  menuItems$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private _config: { [key: string]: any; } = {};
  private _menu: string = '';
  private userEntitlements: any = '';

  constructor(private _portalService: PortalService, private pageService: PageService, private _route: ActivatedRoute, private router: Router) {
    this._config = this.getMenuConfig(this._portalService.getAppSetting("deviceType"));

    // First init menu based on the current route
    this._menu = this.pageService.getPageMenu(this.getPageUri());
    this.menuItems$.next(this.getNav(this._menu));
    console.log(">>>>>>>>>>>> FROM NAVSERVICE - NAV INIT", this.menuItems$);

    // Now listen to route change and update menu
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd), // take only when the navigation start
      filter(event => !(event as NavigationEnd).url.includes('dummy/refresh')) // ignore dummy/refresh
    ).subscribe((e: NavigationEnd) => {
      let currRouteMenu = this.pageService.getPageMenu(this.getPageUri());
      if (this._menu !== currRouteMenu) {
        this._menu = this.pageService.getPageMenu(this.getPageUri());
        this.menuItems$.next(this.getNav(this._menu));
        console.log(">>>>>>>>>>>> FROM NAVSERVICE - UPDATED NAV ON ROUTE CHANGE", this.menuItems$);
      }
    });

  }

  getPageUri() {
    let uri = location.pathname; // pathname contains an initial '/' followed by the path of the URL, not including the query string or fragment.
    if (uri.includes(';')) { // trim away anything comes after ; this is use case for same page navigation
      uri = uri.substring(0, uri.indexOf(';'));
    }
    return uri.substring(uri.lastIndexOf('/') + 1);
  }

  getMenuConfig(deviceType: string) {
    if (!!deviceType && (deviceType === 'mobile' || deviceType === 'tablet')) {
      return this._portalService.getAppSetting("mobileMenuConfig") ?
        this._portalService.getAppSetting("mobileMenuConfig") : this._portalService.getPortalConfig('menu-config-mobile');
    } else {
      return this._portalService.getAppSetting("menuConfig") ?
        this._portalService.getAppSetting("menuConfig") : this._portalService.getPortalConfig('menu-config');
    }
  }

  getNav(menu: string): any {
    this._menu = menu;
    let filteredMenu = [];
    this.userEntitlements = this._portalService.getAppSetting("entitlementJson"); //fetch entitlements to check account
    filteredMenu = this.filterMenu(this._config[menu] ? this._config[menu] : this._config["preLogin"]); //filter the menu against entitlements
    return filteredMenu;
  }

  filterMenu(menu: any) {
    let returnMenu = [];
    menu.forEach(element => { 
      if(!element["entitlements"] || this.checkEntitlement(element["entitlements"])) { //if there are no entitlements on the menu, it is public and we should continue anyway
        if(element["children"] && element["children"].length > 0) { //check if there are lower level menus within the menu
          let filteredChildren = this.filterMenu(element["children"]);  //if there are recurse to parse them
          element["children"] = filteredChildren;
        }
        returnMenu.push(element); //add the item to the menu if it's public or the user is entitled
      }
    })
    return returnMenu;
  }

  checkEntitlement(menuEntitlements: string) {
    for (let entitlement of menuEntitlements.split(" || ")) { //split the or statements
      if(entitlement.includes(" && ")) { //check for and statements
        if(entitlement.split(" && ").every(ent => this.userEntitlements.includes(ent))) { //all and statements must be true
          return true;
        }
      }else if (entitlement === "ANY" || this.userEntitlements.indexOf(entitlement) > -1) { //use else if to avoid parsing && statements twice
          return true;
        }
    }
    return false;
  }
}
